export default __webpack_public_path__ + "static/media/mortgageIcon.a0827b43.png";